import { mobileStatusAtom, store } from '@/store'
import { isMobile } from '@/utils'
import { useEffect } from 'react'

export const useResponsiveStyles = () => {
  // 清理flexible样式
  function cleanupFlexibleStyles() {
    document.documentElement.style.fontSize = '4.8px'
    document.body.style.fontSize = ''
    document.documentElement.classList.remove('hairlines')
  }

  // 移动端专用flexible
  function initializeFlexible() {
    const docEl = document.documentElement
    // const dpr = window.devicePixelRatio || 1;

    function setRemUnit() {
      const uiDesignWidth = 750
      const scale = docEl.clientWidth / uiDesignWidth
      const baseFontSize = 10
      const oneRemPx = baseFontSize * scale

      docEl.style.fontSize = oneRemPx + 'px'
      document.body.style.fontSize = '16px'
    }

    setRemUnit()
  }

  useEffect(() => {
    const loadStyles = () => {
      if (isMobile()) {
        // 只在移动端初始化flexible
        initializeFlexible()
        store.set(mobileStatusAtom, true)
      } else {
        // PC端清理flexible样式
        cleanupFlexibleStyles()
        store.set(mobileStatusAtom, false)
      }
    }

    // 初始加载
    loadStyles()

    window.addEventListener('resize', loadStyles)

    return () => {
      window.removeEventListener('resize', loadStyles)
      cleanupFlexibleStyles()
    }
  }, [])
}
